import React from "react";
import { ArrowRight } from "lucide-react";
import { Button } from "../../../tailwind/button";
import { cn } from "../../../../lib/utils";
import { waBtn } from "../../../../pages/whatsapp/utils/whatsappUiTokens";

export const PlanSelectionFooter = ({
  hasActivePlan,
  selectedPlan,
  onContinue,
  disabled = false,
}) => (
  <div className="flex flex-row items-center justify-end gap-3 pt-1 flex-wrap">
    <p className="text-sm text-gray-500 dark:text-gray-400 text-right">
      {hasActivePlan
        ? "You already have an active subscription."
        : selectedPlan
          ? "Ready to continue with your selected plan."
          : "Select a plan to continue."}
    </p>
    <Button
      className={cn(
        waBtn.primary,
        "h-10 px-6 rounded-lg text-sm inline-flex items-center gap-2 justify-center shrink-0"
      )}
      onClick={() => {
        onContinue && onContinue();
        window.scrollTo({ top: 0, behavior: "smooth" });
      }}
      disabled={!selectedPlan || disabled || hasActivePlan}
    >
      {hasActivePlan
        ? "Change Plan Coming Soon"
        : disabled
          ? "Loading..."
          : "Continue to Checkout"}
      {!hasActivePlan && !disabled && <ArrowRight className="w-4 h-4" />}
    </Button>
  </div>
);
